import React from 'react';

import { useIsMobile } from '../../../hooks';

import SymbolTableRowDesktop from './components/desktop/SymbolTableRowDesktop';
import SymbolTableRowMobile from './components/mobile/SymbolTableRowMobile';
import { SymbolTableRowProps } from './SymbolTableRow.types';

const SymbolTableRow: React.FC<SymbolTableRowProps> = (props) => {
  const {
    id,
    model,
    name,
    hasSwipeableRows,
    swipedRow,
    setSwipedRow,
    onRemove,
    onRowClick,
    oneRowInfoContent,
    gridTemplateColumns,
    isWeek52Item,
    isWithNews,
  } = props;

  const { isMobile } = useIsMobile();

  if (isMobile) {
    const mobileProps: SymbolTableRowProps = {
      id,
      model,
      name,
      hasSwipeableRows,
      swipedRow,
      setSwipedRow,
      onRemove,
      onRowClick,
      isWeek52Item,
      gridTemplateColumns,
    };

    return <SymbolTableRowMobile {...mobileProps} />;
  }

  const desktopProps: SymbolTableRowProps = {
    id,
    model,
    name,
    hasSwipeableRows,
    onRemove,
    onRowClick,
    oneRowInfoContent,
    gridTemplateColumns,
    isWeek52Item,
    isWithNews,
  };

  return <SymbolTableRowDesktop {...desktopProps} />;
};

export default SymbolTableRow;
